import { render, staticRenderFns } from "./commonReportHome.vue?vue&type=template&id=ff720780&scoped=true&"
import script from "./commonReportHome.vue?vue&type=script&lang=js&"
export * from "./commonReportHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff720780",
  null
  
)

export default component.exports